<template>
    <q-dialog v-model="store.confirmOption.open" @hide="onDialogHide" persistent class="confirm">
        <q-card class="q-dialog-plugin">
            <template v-if="store.confirmOption.close">
                <q-card-section class="row items-center q-pb-none" style="padding: 2vmin 2vmin 1vmin;">
                    <div style="font-size: 1vw; font-weight: 700;">{{ store.confirmOption.title }}</div>
                    <q-space />
                    <q-btn class="close" icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-separator />
            </template>
            <div style="padding: 3.33vmin" :style="!store.confirmOption.close && 'margin-top: 1.8vmin;'">
                <div class="confirm__message" v-html="confirmOption.message || ''"></div>
                <div class="confirm__btn" style="display: flex; width: 100%; justify-content: space-between;">
                    <q-btn outline color="primary" :label="confirmOption.cancel || '취소'"
                        @keydown.enter="closeConfirm(false)" @click="closeConfirm(false)"
                        style="width: calc((100% - 1vmin) / 2); font-size: 1.2vw;" />
                    <q-btn color="primary" unelevated :label="confirmOption.ok || '확인'"
                        @keydown.enter="closeConfirm(true)" @click="closeConfirm(true)" style="width: calc((100% - 1vmin) / 2); font-size: 1.2vw;" />
                </div>
            </div>
        </q-card>
    </q-dialog>
</template>

<script setup>
import { computed, onMounted } from 'vue';
// import { useStore } from 'vuex';
import { DialogStore } from "@/store/modules/dialog";
import { soundEffect } from '@/helpers/soundEffect';


const store = DialogStore();
const confirmOption = computed(
    // () => store.state.dialogStore.confirmOption,
    () => store.confirmOption,
);

const closeConfirm = (value) => {
    // console.log('close confirm');
    store.closeConfirmDialog(value);
    // store.commit('dialogStore/closeConfirmDialog', value);
};

const onDialogHide = () => {
    closeConfirm(false)
}

onMounted(() => {
    // soundExit();
    // soundEffect('exit');
})
</script>

<style scoped lang="scss">
.confirm {
    .q-card {
        width: 40%;
        max-width: 580px;
        border-radius: 3.33vmin;
    }

    &__message {
        padding: 0.4vmin 1.87vmin 5vmin;
        // font-size: 2.12vmin;
        font-size: 1.7vw;
        font-weight: 700;
        text-align: center;
        white-space: break-spaces;
    }

    &__btn {
        .q-btn {
            border-radius: 1.33vmin;
            padding: 2vmin 0vmin;
            font-size: 1.2vw;
        }
    }
}
::v-deep {
    .confirm__btn {
        .block {
            font-size: 1.2vw;
            font-weight: 700;
        }
    }
}
.q-btn--actionable.q-btn--standard:before {
    box-shadow: inherit;
}
</style>
